import { useMemo, useState } from 'react'
import * as Resumo from '../../../../../services/api/https/picking/resumo-separcao.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_MISSINGS: 'Salvando faltas',
  SAVE_MISSINGS_SUCCESS: 'Faltas salvas com sucesso',
}

const INITIAL_STATE = {
  selectedEntrega: '',
  modal: {
    show: false,
    data: '',
  },
  globalFilter: '',
  ocorrencias: {},
  allEntregas: [],
  entregas: [],
  selectedRoute: {},
  routes: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useFaltasManualPorRota() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const hasMissingProducts = selectedEntrega => {
      return selectedEntrega.items.filter(i => i.qte_missing_produto > 0).length > 0
    }

    return {
      //Actions
      saveFaltasSeparacaoManual(faltas, picking_id) {
        Resumo.saveFaltasSeparacaoManual(faltas, picking_id)
          .then(() => {
            setState(prevState => {
              const { entregas, selectedEntrega } = prevState
              const index = entregas.findIndex(e => e.cnpj === selectedEntrega.cnpj)
              if (index !== -1)
                entregas[index].has_missing_product = hasMissingProducts(selectedEntrega)
              return {
                ...prevState,
                entregas: entregas,
                loadingMessage: LOAD_MESSAGE.SAVE_MISSINGS_SUCCESS,
              }
            })
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getFalta(entregas) {
        const faltas = []
        entregas.forEach(e => {
          const itemsFaltantes = e.items.filter(i => i.qte_missing_produto > 0)
          if (itemsFaltantes.length > 0) {
            itemsFaltantes.forEach(i => {
              const {
                delivery_item_id,
                missing_reason: { id: missing_reason_id },
                qte_missing_produto,
                delivery_step_id,
                files,
              } = i
              faltas.push({
                delivery_item_id,
                missing_reason_id,
                stage: 'Separacao',
                qte_missing: qte_missing_produto * -1,
                delivery_step_id,
                files,
              })
            })
          }
        })
        return faltas
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events

      onInit(missing_products_by_route, missing_reasons) {
        setState(prevState => ({
          ...prevState,
          ocorrencias: missing_reasons,
          allEntregas: missing_products_by_route,
          routes: missing_products_by_route.map(m => ({
            name: m.placa_prevista_carregamento,
            value: m.placa_prevista_carregamento,
          })),
        }))
      },

      onMenuItemClicked(entrega) {
        setState(prevState => ({
          ...prevState,
          modal: { show: true, data: { items: entrega.items, ocorrencias: prevState.ocorrencias } },
          selectedEntrega: entrega,
        }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: '' } }))
      },

      onModalSave() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_MISSINGS }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onRouteChange(route) {
        setState(prevState => {
          prevState.selectedRoute = route
          prevState.entregas = prevState.allEntregas.find(
            rota => rota.placa_prevista_carregamento === route.value,
          ).clientes
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
